<template>
  <div class="form-group" :class="className">
    <label class="gf_col-sm-4 gf_col-md-5">{{title}}</label>
    <input
      class="gf_col-sm-8 gf_col-md-7"
      type="number"
      :placeholder="placeholder"
      v-model.number="val"
      @input="onInput"
      v-bind="attrs"
      v-on="listeners"
    >
  </div>
</template>

<script>
export default {
  name: "InputNumber",
  props: {
    title: String,
    placeholder: String,
    value: [String, Number],
    className: {
      type: String,
      default: "gf_col-sm-12 gf_col-md-12"
    }
  },
  data() {
    return {
      val: 0
    }
  },
  computed: {
    listeners() {
      const { input, ...listeners } = this.$listeners;
      return listeners;
    },
    attrs() {
      const { rows, ...attrs } = this.$attrs;
      return attrs;
    }
  },
  methods: {
    onInput(e) {
      // let value = e.target.value;
      // console.log(e.target.value);
      this.$emit("input", this.val);
    }
  },
  created() {
    this.val = this.value;
  },
  watch: {
    value(newV) {
      this.val = newV;
    }
  }
};
</script>

<style>
</style>
